module.exports = __webpack_public_path__ + "img/bg4.a2bee234.png";